import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSalaryExternalEmployeeSalaryInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSalaryExternalEmployeeSalaryInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryInfo/exportByPage',
    method: 'post',
    data
  })
}

// 合计
export function sumSalaryExternalEmployeeSalaryInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryInfo/sumByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewSalaryExternalEmployeeSalaryInfoApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryInfo/view',
    method: 'post',
    data
  })
}

// 操作
export function saveSalaryExternalEmployeeSalaryInfoApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryInfo/save',
    method: 'post',
    data
  })
}

